const f = {
  color: {
    background: "#ffffffff",
    border: "#c8d3deff",
    selected: "#304ddbff",
    text: {
      default: "#556575ff",
      disabled: "#7e8e9eff",
      active: "#314351ff"
    }
  }
};
export {
  f as tabBar
};
